/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StartAgentRequest
 */
export interface StartAgentRequest {
  /**
   *
   * @type {string}
   * @memberof StartAgentRequest
   */
  agentType: string;
  /**
   *
   * @type {{ [key: string]: string; }}
   * @memberof StartAgentRequest
   */
  parameters: { [key: string]: string };
  /**
   *
   * @type {boolean}
   * @memberof StartAgentRequest
   */
  dryRun: boolean;
  /**
   *
   * @type {string}
   * @memberof StartAgentRequest
   */
  companyId?: string | null;
  /**
   *
   * @type {string}
   * @memberof StartAgentRequest
   */
  shipmentId?: string | null;
}

/**
 * Check if a given object implements the StartAgentRequest interface.
 */
export function instanceOfStartAgentRequest(
  value: object,
): value is StartAgentRequest {
  if (!("agentType" in value) || value["agentType"] === undefined) return false;
  if (!("parameters" in value) || value["parameters"] === undefined)
    return false;
  if (!("dryRun" in value) || value["dryRun"] === undefined) return false;
  return true;
}

export function StartAgentRequestFromJSON(json: any): StartAgentRequest {
  return StartAgentRequestFromJSONTyped(json, false);
}

export function StartAgentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StartAgentRequest {
  if (json == null) {
    return json;
  }
  return {
    agentType: json["agentType"],
    parameters: json["parameters"],
    dryRun: json["dryRun"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
  };
}

export function StartAgentRequestToJSON(json: any): StartAgentRequest {
  return StartAgentRequestToJSONTyped(json, false);
}

export function StartAgentRequestToJSONTyped(
  value?: StartAgentRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agentType: value["agentType"],
    parameters: value["parameters"],
    dryRun: value["dryRun"],
    companyId: value["companyId"],
    shipmentId: value["shipmentId"],
  };
}
